import type { CoinSeed, CoinVariation } from './types';

const UINT32_MAX_PLUS_ONE = 4_294_967_296;

export function hashCoinSeed(seed: CoinSeed = 0): number {
  if (typeof seed === 'number') {
    if (!Number.isFinite(seed)) return 0;
    let value = Math.trunc(seed) >>> 0;
    value = Math.imul(value ^ (value >>> 16), 0x45d9f3b);
    value = Math.imul(value ^ (value >>> 16), 0x45d9f3b);
    return (value ^ (value >>> 16)) >>> 0;
  }

  let hash = 0x811c9dc5;
  for (let index = 0; index < seed.length; index += 1) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

export function createCoinRandom(seed: CoinSeed = 0): () => number {
  let state = hashCoinSeed(seed);
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let value = state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / UINT32_MAX_PLUS_ONE;
  };
}

export function createCoinVariation(seed: CoinSeed = 0): CoinVariation {
  const normalizedSeed = hashCoinSeed(seed);
  const random = createCoinRandom(normalizedSeed);
  return Object.freeze({
    seed: normalizedSeed,
    mintRotation: (random() - 0.5) * 0.07,
    tint: 0.92 + random() * 0.13,
    patina: random(),
  });
}
